<template>
  <generic-modal :modal-key="'confirm_purchase'" :has-extra-modal-class="'store_popup_box purchase purchase_success modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_confirm_purchase_successfull_purchase }}</h1>
        <img src="static/images/store/photo-success.png" class="purchase_img">
        <h2>{{ getTranslations.home_modals_confirm_purchase_well_done }}</h2>
      <p>{{ getTranslations.home_modals_confirm_purchase_successfull_games_were_unlocked }}
        {{getBundleData.numberOfGames ? getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_successfull_games :''}}
        {{getBundleData.numberOfGames && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :''}}
        {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_successfull_points : '' }}
        <br> {{ getTranslations.home_modals_confirm_purchase_successfull_do_you_want_to_start_new_game }}</p>
        <button type="" @click.prevent="playMethod">
          {{ getTranslations.home_modals_confirm_purchase_successfull_new_game }}
        </button>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'confirmPurchaseSuccessful',
  components: { GenericModal },
  mixins: [NewGameMixin],
  methods: {
    playMethod() {
      this.playGame();
    },
  },
  computed: {
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseSuccessful.vue